"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_RESPONSE_STATUS_CODE = exports.FormattedAxiosError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _trimText = require("./trimText");
/**
 * Represents a status code of `0` to indicate that no response was received from the server.
 *
 * @remarks
 * This constant is used in scenarios where the HTTP request did not reach the server or the server
 * did not provide a valid response, such as when the network is unavailable, the request times out,
 * or there's a CORS error. Since `0` is not a valid HTTP status code, it serves as a special
 * placeholder to signal the absence of any server response.
 */
const NO_RESPONSE_STATUS_CODE = exports.NO_RESPONSE_STATUS_CODE = 0;

/**
 * This formats ExtendedAxiosError into more readable object for logging only
 */
class FormattedAxiosError extends Error {
  constructor(axiosError) {
    super(`Axios Error: ${axiosError.message}`);
    (0, _defineProperty2.default)(this, "baseUrl", void 0);
    (0, _defineProperty2.default)(this, "pathname", void 0);
    (0, _defineProperty2.default)(this, "method", void 0);
    (0, _defineProperty2.default)(this, "statusCode", void 0);
    (0, _defineProperty2.default)(this, "statusText", void 0);
    (0, _defineProperty2.default)(this, "responseBody", null);
    (0, _defineProperty2.default)(this, "callstack", void 0);
    this.name = 'FormattedAxiosError';
    this.baseUrl = axiosError.baseUrl;
    this.pathname = axiosError.pathname;
    this.method = axiosError.method;
    this.statusCode = axiosError.statusCode;
    this.statusText = axiosError.statusText;

    // No need to pass body on 404 and empty body
    if (this.statusCode !== 404 && axiosError.responseBody != null) {
      if (process.env.NODE_ENV === 'production') {
        // Make sure that body is trimmed so we won't overfill Application Insights
        this.responseBody = (0, _trimText.trimText)(JSON.stringify(axiosError.responseBody));
      } else {
        this.responseBody = JSON.stringify(axiosError.responseBody, null, 2);
      }
    }
    this.callstack = axiosError.callstack;
  }
}
exports.FormattedAxiosError = FormattedAxiosError;
//# sourceMappingURL=FormattedAxiosError.js.map